import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import SteddyStar from "@/components/SteddyStar";

const navLinks = [
  { label: "Our Approach", href: "#platform" },
  { label: "Services", href: "#features" },
  { label: "Solutions", href: "#solutions" },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <motion.nav
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.2, 0.8, 0.2, 1] }}
      className="fixed left-0 right-0 top-[var(--env-ribbon-height)] z-50 border-b border-border/50 bg-background/90 backdrop-blur-xl"
    >
      <div className="container mx-auto flex h-16 items-center justify-between px-6">
        <a href="#" className="flex items-center gap-1.5">
          <span className="text-xl font-bold tracking-tight text-foreground">Steddy</span>
          <SteddyStar className="-mt-2.5 h-3.5 w-3.5 text-primary" />
        </a>

        <div className="hidden items-center gap-1 rounded-full bg-secondary px-2 py-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="steddy-transition rounded-full px-4 py-2 text-sm text-muted-foreground hover:bg-background hover:text-foreground"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a href="/login" className="btn-outline-steddy px-5 py-2 text-xs">
            Partner With Us
          </a>
          <a href="/login" className="btn-primary-steddy px-5 py-2 text-xs">
            Deploy Steddy
          </a>
        </div>

        <button className="text-foreground md:hidden" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {mobileOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="flex flex-col gap-3 border-t border-border/50 bg-background px-6 py-4 md:hidden"
        >
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="py-2 text-sm text-muted-foreground"
              onClick={() => setMobileOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a href="/login" className="btn-primary-steddy mt-2 text-center">
            Deploy Steddy
          </a>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;
